import * as i0 from '@angular/core';
import { Injectable, Component, Optional, Inject, Input, NgModule, SkipSelf } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import * as i4 from '@roosevelt/common-ui-lib/notification';
import { NotificationModule } from '@roosevelt/common-ui-lib/notification';
import * as i5 from '@roosevelt/common-ui-lib/button';
import { ButtonModule } from '@roosevelt/common-ui-lib/button';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

class NLConstants {
    static { this.ERROR = "error"; }
    static { this.SUCCESS = "success"; }
}

const APP_NAME_CONSTANTS = Object.freeze({
    CLAIM_ADMIN: 'CLAIM_ADMIN',
});

class NotificationService {
    constructor() {
        this._notifications$ = new BehaviorSubject(new Map());
        this.notificationsByType = new Map();
    }
    get notifications$() {
        return this._notifications$;
    }
    showNotification(tag, type, messages, traceId, showErrorLink, emailMessages) {
        console.log(tag);
        console.log(messages);
        console.log(traceId);
        const notificationObject = Object.assign({
            'traceId': traceId,
            'messages': messages,
            'emailMessages': emailMessages,
            'showErrorLink': showErrorLink
        });
        if (type === NLConstants.ERROR) {
            const notificationByTag = this.notificationsByType.has(NLConstants.ERROR) ? this.notificationsByType.get(NLConstants.ERROR) : new Map();
            notificationByTag.set(tag, notificationObject);
            this.notificationsByType.set(NLConstants.ERROR, new Map(notificationByTag));
            this._notifications$.next(new Map(this.notificationsByType));
        }
        else if (type === NLConstants.SUCCESS) {
            const notificationByTag = this.notificationsByType.has(NLConstants.SUCCESS) ? this.notificationsByType.get(NLConstants.SUCCESS) : new Map();
            notificationByTag.set(tag, notificationObject);
            this.notificationsByType.set(NLConstants.SUCCESS, new Map(notificationByTag));
            this._notifications$.next(new Map(this.notificationsByType));
        }
    }
    clearNotification(tag, type) {
        if (type === NLConstants.ERROR) {
            const notificationByTag = this.notificationsByType.has(NLConstants.ERROR) ? this.notificationsByType.get(NLConstants.ERROR) : undefined;
            if (notificationByTag) {
                const removed = notificationByTag.has(tag) ? notificationByTag.delete(tag) : false;
                if (removed) {
                    this.notificationsByType.set(NLConstants.ERROR, new Map(notificationByTag));
                    this.notifications$.next(new Map(this.notificationsByType));
                }
            }
        }
        else if (type === NLConstants.SUCCESS) {
            const notificationByTag = this.notificationsByType.has(NLConstants.SUCCESS) ? this.notificationsByType.get(NLConstants.SUCCESS) : undefined;
            if (notificationByTag) {
                const removed = notificationByTag.has(tag) ? notificationByTag.delete(tag) : false;
                if (removed) {
                    this.notificationsByType.set(NLConstants.SUCCESS, new Map(notificationByTag));
                    this.notifications$.next(new Map(this.notificationsByType));
                }
            }
        }
    }
    clearAllNotifications() {
        this.notificationsByType.clear();
        this.notifications$.next(new Map(this.notificationsByType));
    }
    static { this.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

class NotificationConfig {
}

const _c0 = a0 => ({ "list-style": a0 });
function NotificationComponent_ng_container_0_li_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 5)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const message_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.appName === ctx_r1.APP_NAME_CONSTANTS.CLAIM_ADMIN && ctx_r1.isWarningMessage(message_r3) ? "error-li nui-pb-5" : "error-li");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(message_r3);
} }
function NotificationComponent_ng_container_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function NotificationComponent_ng_container_0_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.mailto()); });
    i0.ɵɵtext(1, " REPORT THIS ISSUE ");
    i0.ɵɵelementEnd();
} }
function NotificationComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "rs-notification", 1);
    i0.ɵɵlistener("visibleChange", function NotificationComponent_ng_container_0_Template_rs_notification_visibleChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.errorHidden = !$event); });
    i0.ɵɵelementStart(2, "ul", 2);
    i0.ɵɵtemplate(3, NotificationComponent_ng_container_0_li_3_Template, 3, 2, "li", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, NotificationComponent_ng_container_0_button_4_Template, 2, 0, "button", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.type)("visible", !ctx_r1.errorHidden)("message", ctx_r1.type === "error" ? "Exception(s)" : "Success");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(6, _c0, (ctx_r1.messages == null ? null : ctx_r1.messages.length) > 1 ? "inside" : "none"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.messages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.type === "error" && ctx_r1.showErrorLink);
} }
function NotificationComponent_ng_container_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function NotificationComponent_ng_container_1_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.mailto()); });
    i0.ɵɵtext(1, " REPORT THIS ISSUE ");
    i0.ɵɵelementEnd();
} }
function NotificationComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "rs-notification", 1);
    i0.ɵɵlistener("visibleChange", function NotificationComponent_ng_container_1_Template_rs_notification_visibleChange_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.errorHidden = !$event); });
    i0.ɵɵtemplate(2, NotificationComponent_ng_container_1_button_2_Template, 2, 0, "button", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("type", ctx_r1.type)("visible", !ctx_r1.errorHidden)("message", ctx_r1.messages[0]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.type === "error" && ctx_r1.showErrorLink);
} }
/**
 * Notification Component
 *
 * @description if you are looking for the notification component please go to https://tst.my.rooseveltsolutions.com/style-guide/content/NotificationModule/NotificationComponent#Playground
 * @example <lib-notification [tags]="['CLAIM_SEARCH']" type="error"></lib-notification>
 * @example <lib-notification [tags]="['CLAIM_DETAIL_S']" type="success"></lib-notification>
 * @example <lib-notification [tags]="['SAVE_CLAIM']" type="error"></lib-notification>
 * @example <lib-notification [tags]="['CLAIM_DETAIL_SM']" type="success"></lib-notification>
 * @example <lib-notification [tags]="['CLAIM_ADMIN_ADJ_E']" type="error" appName="CLAIM_ADMIN"></lib-notification>
 */
class NotificationComponent {
    constructor(notificationService, zone, userInfoKey, region, email, config) {
        this.notificationService = notificationService;
        this.zone = zone;
        this.userInfoKey = userInfoKey;
        this.region = region;
        this.email = email;
        this.config = config;
        this.errorHidden = true;
        this.successHidden = true;
        this.APP_NAME_CONSTANTS = APP_NAME_CONSTANTS;
        //traceId: string;
        this.subscriptions = [];
        this.reportEmail = this.config ? this.config.email : email ? email : '';
    }
    mailto() {
        window.open("mailto:" + this.reportEmail + '?subject=' + this.reportSubject + '&body=' + this.reportBody);
    }
    ngOnInit() {
        this.subscriptions.push(this.notificationService.notifications$.subscribe((notificationsByType) => {
            this.messages = [];
            this.errorHidden = true;
            if (this.type === NLConstants.ERROR) {
                const notificationsByTag = notificationsByType.get(NLConstants.ERROR);
                this.publishErrorNotifications(notificationsByTag);
            }
            else if (this.type === NLConstants.SUCCESS) {
                const notificationsByTag = notificationsByType.get(NLConstants.SUCCESS);
                this.publishErrorNotifications(notificationsByTag);
            }
        }));
    }
    publishErrorNotifications(errorNotificationsByTag) {
        if (errorNotificationsByTag) {
            this.tags.forEach(eachTag => {
                if (errorNotificationsByTag.has(eachTag)) {
                    const messages = errorNotificationsByTag.get(eachTag).messages;
                    this.messages = this.messages.concat(messages);
                }
            });
            if (this.type === NLConstants.ERROR)
                this.buildReportIssueContent(errorNotificationsByTag);
            if (this.messages && this.messages.length > 0) {
                this.errorHidden = false;
                this.zone.run(() => { });
            }
        }
    }
    getStatus() {
        if (this.type == 'error') {
            return 'Exception(s)';
        }
        else {
            return 'Success';
        }
        return "";
    }
    buildReportIssueContent(notificationsByTag) {
        this.reportBody = "";
        this.reportSubject = 'Exception in ' + (this.config ? this.config.region : this.region);
        this.tags.forEach(eachTag => {
            if (notificationsByTag.has(eachTag)) {
                const traceId = notificationsByTag.get(eachTag).traceId;
                this.showErrorLink = notificationsByTag.get(eachTag).showErrorLink;
                const messages = this.getEmailMessages(notificationsByTag, eachTag);
                this.reportBody = 'Here are the details. %0D%0A%0D%0ATag:: ' + ((eachTag) ? eachTag : 'N/A') + '%0D%0A%0D%0ATraceId:: ' + ((traceId) ? traceId : 'N/A') + '%0D%0A%0D%0AExceptions::' + '%0D%0A';
                messages.forEach(eachException => {
                    this.reportBody = this.reportBody + eachException + '%0D%0A';
                });
                this.reportBody = this.reportBody + '%0D%0A';
            }
        });
        const userInfo = this.config ? { firstName: this.config.firstName, lastName: this.config.lastName, id: this.config.userId } : this.getUserInfo();
        if (userInfo)
            this.reportBody = this.reportBody + '%0D%0AThank you,%0D%0A' + userInfo.firstName + ' ' + userInfo.lastName + ' (' + userInfo.id + ')';
    }
    getEmailMessages(notificationsByTag, tag) {
        if (notificationsByTag.get(tag).emailMessages?.length > 0) {
            return notificationsByTag.get(tag).emailMessages;
        }
        return notificationsByTag.get(tag).messages;
    }
    getUserInfo() {
        return JSON.parse(this.userInfoKey);
    }
    isWarningMessage(message) {
        if (!message) {
            return false;
        }
        const msg = message.trim();
        return msg.split(' ')[0] === 'WARNING:';
    }
    ngOnDestroy() {
        this.subscriptions.forEach((x) => x.unsubscribe());
    }
    static { this.ɵfac = function NotificationComponent_Factory(t) { return new (t || NotificationComponent)(i0.ɵɵdirectiveInject(NotificationService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject('userInfoKey', 8), i0.ɵɵdirectiveInject('region', 8), i0.ɵɵdirectiveInject('email', 8), i0.ɵɵdirectiveInject(NotificationConfig, 8)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationComponent, selectors: [["lib-notification"]], inputs: { tags: "tags", type: "type", appName: "appName" }, decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "visibleChange", "type", "visible", "message"], [3, "ngStyle"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["rs-button", "", "class", "nui-report-issue", 3, "click", 4, "ngIf"], [3, "ngClass"], ["rs-button", "", 1, "nui-report-issue", 3, "click"]], template: function NotificationComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, NotificationComponent_ng_container_0_Template, 5, 8, "ng-container", 0)(1, NotificationComponent_ng_container_1_Template, 3, 4, "ng-container", 0);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.messages.length > 1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.messages.length === 1);
        } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgStyle, i4.NotificationComponent, i5.ButtonComponent], styles: [".nui-report-issue[_ngcontent-%COMP%]{padding-top:0;padding-left:0;padding-bottom:0;min-height:20px}.nui-report-issue[_ngcontent-%COMP%]:hover{text-decoration:underline}.nui-pb-5[_ngcontent-%COMP%]{margin-bottom:10px!important;color:red}"] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationComponent, [{
        type: Component,
        args: [{ selector: 'lib-notification', template: "<ng-container *ngIf=\"messages.length>1\">\n  <rs-notification [type]=\"type\" [visible]=\"!errorHidden\" (visibleChange)=\"errorHidden = !$event\"\n    [message]=\"type ==='error' ? 'Exception(s)': 'Success'\">\n\n    <ul [ngStyle]=\"{'list-style':(messages?.length > 1)? 'inside':'none'}\">\n      <li *ngFor=\"let message of messages\" [ngClass]=\"appName===APP_NAME_CONSTANTS.CLAIM_ADMIN && isWarningMessage(message) ? 'error-li nui-pb-5' : 'error-li'\">\n        <span>{{message}}</span>\n      </li>\n    </ul>\n    <button rs-button *ngIf=\"type==='error'&&showErrorLink\" class=\"nui-report-issue\" (click)=\"mailto()\">\n      REPORT THIS ISSUE\n    </button>\n  </rs-notification>\n</ng-container>\n<ng-container *ngIf=\"messages.length===1\">\n  <rs-notification [type]=\"type\" [visible]=\"!errorHidden\" (visibleChange)=\"errorHidden = !$event\"\n    [message]=\"messages[0]\">\n    <button rs-button *ngIf=\"type==='error'&&showErrorLink\" class=\"nui-report-issue\" (click)=\"mailto()\">\n      REPORT THIS ISSUE\n    </button>\n  </rs-notification>\n</ng-container>\n", styles: [".nui-report-issue{padding-top:0;padding-left:0;padding-bottom:0;min-height:20px}.nui-report-issue:hover{text-decoration:underline}.nui-pb-5{margin-bottom:10px!important;color:red}\n"] }]
    }], () => [{ type: NotificationService }, { type: i0.NgZone }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: ['userInfoKey']
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: ['region']
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: ['email']
            }] }, { type: NotificationConfig, decorators: [{
                type: Optional
            }] }], { tags: [{
            type: Input
        }], type: [{
            type: Input
        }], appName: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(NotificationComponent, { className: "NotificationComponent", filePath: "lib/components/notification/notification.component.ts", lineNumber: 25 }); })();

class NotificationLibModule {
    constructor(parentModule) {
        // if (parentModule) {
        //   throw new Error(
        //     'NotificationLibModule is already loaded. Import it in the AppModule only');
        // }
    }
    static forRoot() {
        return {
            ngModule: NotificationLibModule,
            providers: [
                NotificationService
            ]
        };
    }
    static { this.ɵfac = function NotificationLibModule_Factory(t) { return new (t || NotificationLibModule)(i0.ɵɵinject(NotificationLibModule, 12)); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NotificationLibModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [provideHttpClient(withInterceptorsFromDi())], imports: [CommonModule,
            NotificationModule,
            ButtonModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationLibModule, [{
        type: NgModule,
        args: [{ declarations: [NotificationComponent],
                exports: [
                    NotificationComponent
                ], imports: [CommonModule,
                    NotificationModule,
                    ButtonModule], providers: [provideHttpClient(withInterceptorsFromDi())] }]
    }], () => [{ type: NotificationLibModule, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }], null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NotificationLibModule, { declarations: [NotificationComponent], imports: [CommonModule,
        NotificationModule,
        ButtonModule], exports: [NotificationComponent] }); })();

/*
 * Public API Surface of notification-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NotificationComponent, NotificationConfig, NotificationLibModule, NotificationService };
